import keyEventMatchers from '@intercom/embercom-composer/lib/editor/event-translators/key-event-matchers';

// Translate a keydown event into a composer action
export default function (e) {
  let action;
  for (let i = 0; i < ACTIONS.length; i++) {
    action = ACTIONS[i];
    if (keyEventMatchers[action.matcher](e)) {
      return {
        type: action.type,
        preventDefault: action.preventDefault,
        direction: action.direction
      };
    }
  }
  // If there are no matches then this is the default action
  return {
    type: 'typing',
    preventDefault: false,
    direction: null
  };
}
const ACTIONS = [{
  type: 'bold',
  matcher: 'isBold',
  preventDefault: true
}, {
  type: 'italic',
  matcher: 'isItalic',
  preventDefault: true
}, {
  type: 'anchor',
  matcher: 'isAnchor',
  preventDefault: true
}, {
  type: 'underline',
  matcher: 'isUnderline',
  preventDefault: true
}, {
  type: 'redo',
  matcher: 'isRedo',
  preventDefault: true
}, {
  type: 'undo',
  matcher: 'isUndo',
  preventDefault: true
}, {
  type: 'selectAll',
  matcher: 'isSelectAll',
  preventDefault: true
}, {
  type: 'shiftSelection',
  matcher: 'isShiftSelection',
  preventDefault: false
}, {
  type: 'navigation',
  matcher: 'isNavigationLeft',
  preventDefault: false,
  direction: 'left'
}, {
  type: 'navigation',
  matcher: 'isNavigationRight',
  preventDefault: false,
  direction: 'right'
}, {
  type: 'navigation',
  matcher: 'isNavigationUp',
  preventDefault: false,
  direction: 'up'
}, {
  type: 'navigation',
  matcher: 'isNavigationDown',
  preventDefault: false,
  direction: 'down'
}, {
  type: 'navigation',
  matcher: 'isNavigation',
  preventDefault: false
}, {
  type: 'deleteToStartOfLine',
  matcher: 'isDeleteToStartOfLine',
  preventDefault: true
}, {
  type: 'delete',
  matcher: 'isDelete',
  preventDefault: false
}, {
  type: 'deleteWord',
  matcher: 'isDeleteWord',
  preventDefault: true
}, {
  type: 'backspaceWord',
  matcher: 'isBackspaceWord',
  preventDefault: true
}, {
  type: 'backspace',
  matcher: 'isBackspace',
  preventDefault: false
}, {
  type: 'submit',
  matcher: 'isSubmit',
  preventDefault: true
}, {
  type: 'softEnter',
  matcher: 'isSoftEnter',
  preventDefault: true
}, {
  type: 'enter',
  matcher: 'isEnter',
  preventDefault: true
}, {
  type: 'removeFocus',
  matcher: 'isRemoveFocus',
  preventDefault: true
}, {
  type: 'tab',
  matcher: 'isTab',
  preventDefault: false
}, {
  type: 'copyAction',
  matcher: 'isCopy',
  preventDefault: false
}, {
  type: 'cutAction',
  matcher: 'isCut',
  preventDefault: false
}, {
  type: 'pasteAction',
  matcher: 'isPaste',
  preventDefault: false
}, {
  type: 'toggleDebugOutlines',
  matcher: 'isToggleDebugOutlines',
  preventDefault: false
}, {
  type: 'throwDebugException',
  matcher: 'isThrowDebugException',
  preventDefault: false
}];